import { Card, Service } from "@yleisradio/areena-types";

import { CONTENT_TYPE } from "../enums";
import { ContentType } from "../types/player-api";

export const contentTypeToService = (contentType: ContentType): Service => {
  switch (contentType) {
    case CONTENT_TYPE.AUDIO_OBJECT:
      return "radio";
    case CONTENT_TYPE.VIDEO_OBJECT:
      return "tv";
    default:
      throw new Error(`Unknown content type ${contentType}`);
  }
};

export const getYleIdFromCard = (card: Card): string | undefined =>
  card.labels?.find(l => l.type === "itemId")?.raw;

export const getYleIdFromCardOrThrow = (card: Card): string => {
  const id = getYleIdFromCard(card);

  if (!id) throw new Error("Missing itemId label in card");

  return id;
};

const isString = (maybeString: string | undefined): maybeString is string =>
  typeof maybeString === "string";

export const getYleIdsFromCards = (cards: Card[]): string[] =>
  cards.map(getYleIdFromCard).filter(isString);
